@file:OptIn(InternalResourceApi::class)

package showcaseapp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.RegionQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/showcaseapp.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_436_107_614)
internal val Res.string.showcase_style: StringResource by lazy {
      StringResource("string:showcase_style", "showcase_style", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21221, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24103, 30),
      ))
    }

@delegate:ResourceContentHash(1_883_429_106)
internal val Res.string.slide_effect: StringResource by lazy {
      StringResource("string:slide_effect", "slide_effect", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21252, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24134, 36),
      ))
    }

@delegate:ResourceContentHash(-1_454_523_806)
internal val Res.string.slow: StringResource by lazy {
      StringResource("string:slow", "slow", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21289, 16),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24171, 20),
      ))
    }

@delegate:ResourceContentHash(794_333_285)
internal val Res.string.small: StringResource by lazy {
      StringResource("string:small", "small", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21306, 17),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24192, 21),
      ))
    }

@delegate:ResourceContentHash(532_371_277)
internal val Res.string.sort_rule: StringResource by lazy {
      StringResource("string:sort_rule", "sort_rule", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21565, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24405, 29),
      ))
    }

@delegate:ResourceContentHash(-1_305_450_041)
internal val Res.string.sort_rule_date_asc: StringResource by lazy {
      StringResource("string:sort_rule_date_asc", "sort_rule_date_asc", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21324, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24214, 38),
      ))
    }

@delegate:ResourceContentHash(-372_670_598)
internal val Res.string.sort_rule_date_desc: StringResource by lazy {
      StringResource("string:sort_rule_date_desc", "sort_rule_date_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21367, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24253, 39),
      ))
    }

@delegate:ResourceContentHash(-162_988_294)
internal val Res.string.sort_rule_default: StringResource by lazy {
      StringResource("string:sort_rule_default", "sort_rule_default", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21411, 33),
      ))
    }

@delegate:ResourceContentHash(1_288_437_622)
internal val Res.string.sort_rule_name_asc: StringResource by lazy {
      StringResource("string:sort_rule_name_asc", "sort_rule_name_asc", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21445, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24293, 38),
      ))
    }

@delegate:ResourceContentHash(-2_073_750_231)
internal val Res.string.sort_rule_name_desc: StringResource by lazy {
      StringResource("string:sort_rule_name_desc", "sort_rule_name_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21488, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24332, 39),
      ))
    }

@delegate:ResourceContentHash(850_768_756)
internal val Res.string.sort_rule_random: StringResource by lazy {
      StringResource("string:sort_rule_random", "sort_rule_random", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21532, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24372, 32),
      ))
    }

@delegate:ResourceContentHash(-397_300_270)
internal val Res.string.source: StringResource by lazy {
      StringResource("string:source", "source", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22121, 18),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25029, 22),
      ))
    }

@delegate:ResourceContentHash(-1_755_109_146)
internal val Res.string.source_name: StringResource by lazy {
      StringResource("string:source_name", "source_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21654, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24506, 35),
      ))
    }

@delegate:ResourceContentHash(-476_674_208)
internal val Res.string.source_name_already_exists: StringResource by lazy {
      StringResource("string:source_name_already_exists", "source_name_already_exists", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21599, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24435, 70),
      ))
    }

@delegate:ResourceContentHash(755_419_968)
internal val Res.string.source_preference: StringResource by lazy {
      StringResource("string:source_preference", "source_preference", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21682, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24542, 49),
      ))
    }

@delegate:ResourceContentHash(1_766_617_567)
internal val Res.string.source_type_category_album_services: StringResource by lazy {
      StringResource("string:source_type_category_album_services", "source_type_category_album_services", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21720, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24592, 63),
      ))
    }

@delegate:ResourceContentHash(366_897_979)
internal val Res.string.source_type_category_local: StringResource by lazy {
      StringResource("string:source_type_category_local", "source_type_category_local", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21780, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24656, 42),
      ))
    }

@delegate:ResourceContentHash(-1_689_090_135)
internal val Res.string.source_type_category_network_storage: StringResource by lazy {
      StringResource("string:source_type_category_network_storage", "source_type_category_network_storage", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21823, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24699, 80),
      ))
    }

@delegate:ResourceContentHash(870_104_971)
internal val Res.string.source_type_category_other_online_content: StringResource by lazy {
      StringResource("string:source_type_category_other_online_content", "source_type_category_other_online_content", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21892, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24780, 77),
      ))
    }

@delegate:ResourceContentHash(840_502_839)
internal val Res.string.source_type_category_third_party: StringResource by lazy {
      StringResource("string:source_type_category_third_party", "source_type_category_third_party", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21958, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24858, 68),
      ))
    }

@delegate:ResourceContentHash(-1_193_381_998)
internal val Res.string.source_type_gallery: StringResource by lazy {
      StringResource("string:source_type_gallery", "source_type_gallery", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22019, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24927, 39),
      ))
    }

@delegate:ResourceContentHash(43_735_532)
internal val Res.string.source_type_local: StringResource by lazy {
      StringResource("string:source_type_local", "source_type_local", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22055, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24967, 33),
      ))
    }

@delegate:ResourceContentHash(-1_466_897_868)
internal val Res.string.sources: StringResource by lazy {
      StringResource("string:sources", "sources", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22101, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25001, 27),
      ))
    }

@delegate:ResourceContentHash(269_196_594)
internal val Res.string.sub_folder_hint: StringResource by lazy {
      StringResource("string:sub_folder_hint", "sub_folder_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22140, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25052, 39),
      ))
    }

@delegate:ResourceContentHash(1_938_540_577)
internal val Res.string.subtle: StringResource by lazy {
      StringResource("string:subtle", "subtle", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22176, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25092, 22),
      ))
    }

@delegate:ResourceContentHash(2_118_838_544)
internal val Res.string.system: StringResource by lazy {
      StringResource("string:system", "system", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22289, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25209, 22),
      ))
    }

@delegate:ResourceContentHash(-1_280_698_434)
internal val Res.string.system_default: StringResource by lazy {
      StringResource("string:system_default", "system_default", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22199, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25115, 42),
      ))
    }

@delegate:ResourceContentHash(-702_284_471)
internal val Res.string.system_screensaver: StringResource by lazy {
      StringResource("string:system_screensaver", "system_screensaver", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22238, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25158, 50),
      ))
    }

@delegate:ResourceContentHash(1_088_420_439)
internal val Res.string.telegram_channel: StringResource by lazy {
      StringResource("string:telegram_channel", "telegram_channel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25232, 48),
      ))
    }

@delegate:ResourceContentHash(1_352_046_323)
internal val Res.string.terms_of_use: StringResource by lazy {
      StringResource("string:terms_of_use", "terms_of_use", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22312, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25281, 36),
      ))
    }

@delegate:ResourceContentHash(1_755_317_835)
internal val Res.string.test_connection: StringResource by lazy {
      StringResource("string:test_connection", "test_connection", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22349, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25318, 43),
      ))
    }

@delegate:ResourceContentHash(1_650_393_320)
internal val Res.string.thanks: StringResource by lazy {
      StringResource("string:thanks", "thanks", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22389, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25428, 22),
      ))
    }

@delegate:ResourceContentHash(-1_150_806_641)
internal val Res.string.thanks_for_your_feed_back: StringResource by lazy {
      StringResource("string:thanks_for_your_feed_back", "thanks_for_your_feed_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25362, 65),
      ))
    }

@delegate:ResourceContentHash(1_271_015_596)
internal val Res.string.the_number_of_files_may_be_too_large_please_wait: StringResource by lazy {
      StringResource("string:the_number_of_files_may_be_too_large_please_wait", "the_number_of_files_may_be_too_large_please_wait", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22412, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25451, 124),
      ))
    }

@delegate:ResourceContentHash(-80_856_990)
internal val Res.string.theme_style: StringResource by lazy {
      StringResource("string:theme_style", "theme_style", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22896, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25967, 35),
      ))
    }

@delegate:ResourceContentHash(1_356_468_273)
internal val Res.string.theme_style_atlas: StringResource by lazy {
      StringResource("string:theme_style_atlas", "theme_style_atlas", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22509, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25576, 33),
      ))
    }

@delegate:ResourceContentHash(1_743_675_195)
internal val Res.string.theme_style_aurora: StringResource by lazy {
      StringResource("string:theme_style_aurora", "theme_style_aurora", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22543, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25610, 34),
      ))
    }

@delegate:ResourceContentHash(-483_319_171)
internal val Res.string.theme_style_coast: StringResource by lazy {
      StringResource("string:theme_style_coast", "theme_style_coast", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22578, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25645, 33),
      ))
    }

@delegate:ResourceContentHash(-559_882_532)
internal val Res.string.theme_style_forest: StringResource by lazy {
      StringResource("string:theme_style_forest", "theme_style_forest", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22612, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25679, 34),
      ))
    }

@delegate:ResourceContentHash(-1_613_024_096)
internal val Res.string.theme_style_herbarium: StringResource by lazy {
      StringResource("string:theme_style_herbarium", "theme_style_herbarium", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22647, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25714, 41),
      ))
    }

@delegate:ResourceContentHash(-2_088_727_745)
internal val Res.string.theme_style_journal: StringResource by lazy {
      StringResource("string:theme_style_journal", "theme_style_journal", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22689, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25756, 39),
      ))
    }

@delegate:ResourceContentHash(454_588_182)
internal val Res.string.theme_style_noir: StringResource by lazy {
      StringResource("string:theme_style_noir", "theme_style_noir", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22725, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25796, 32),
      ))
    }

@delegate:ResourceContentHash(981_591_840)
internal val Res.string.theme_style_oled: StringResource by lazy {
      StringResource("string:theme_style_oled", "theme_style_oled", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22758, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25829, 32),
      ))
    }

@delegate:ResourceContentHash(-1_142_401_722)
internal val Res.string.theme_style_orchid: StringResource by lazy {
      StringResource("string:theme_style_orchid", "theme_style_orchid", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22791, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25862, 34),
      ))
    }

@delegate:ResourceContentHash(-1_317_052_425)
internal val Res.string.theme_style_signal: StringResource by lazy {
      StringResource("string:theme_style_signal", "theme_style_signal", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22826, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25897, 34),
      ))
    }

@delegate:ResourceContentHash(1_609_300_474)
internal val Res.string.theme_style_sunset: StringResource by lazy {
      StringResource("string:theme_style_sunset", "theme_style_sunset", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22861, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25932, 34),
      ))
    }

@delegate:ResourceContentHash(-851_918_311)
internal val Res.string.time_unit_minute: StringResource by lazy {
      StringResource("string:time_unit_minute", "time_unit_minute", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22932, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26003, 32),
      ))
    }

@delegate:ResourceContentHash(1_854_158_696)
internal val Res.string.time_unit_second: StringResource by lazy {
      StringResource("string:time_unit_second", "time_unit_second", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22965, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26036, 32),
      ))
    }

@delegate:ResourceContentHash(-186_741_356)
internal val Res.string.timecard_date_pattern: StringResource by lazy {
      StringResource("string:timecard_date_pattern", "timecard_date_pattern", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 22994, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26069, 49),
      ))
    }

@delegate:ResourceContentHash(53_764_409)
internal val Res.string.timecard_weather_loading: StringResource by lazy {
      StringResource("string:timecard_weather_loading", "timecard_weather_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23052, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26119, 36),
      ))
    }

@delegate:ResourceContentHash(75_053_696)
internal val Res.string.timecard_weather_unavailable: StringResource by lazy {
      StringResource("string:timecard_weather_unavailable", "timecard_weather_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23089, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26156, 40),
      ))
    }

@delegate:ResourceContentHash(-1_546_705_222)
internal val Res.string.timecard_weekday_friday: StringResource by lazy {
      StringResource("string:timecard_weekday_friday", "timecard_weekday_friday", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23130, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26197, 35),
      ))
    }

@delegate:ResourceContentHash(-1_546_676_573)
internal val Res.string.timecard_weekday_monday: StringResource by lazy {
      StringResource("string:timecard_weekday_monday", "timecard_weekday_monday", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23170, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26233, 35),
      ))
    }

@delegate:ResourceContentHash(-1_546_310_439)
internal val Res.string.timecard_weekday_saturday: StringResource by lazy {
      StringResource("string:timecard_weekday_saturday", "timecard_weekday_saturday", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23210, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26269, 37),
      ))
    }

@delegate:ResourceContentHash(-1_545_610_514)
internal val Res.string.timecard_weekday_sunday: StringResource by lazy {
      StringResource("string:timecard_weekday_sunday", "timecard_weekday_sunday", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23252, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26307, 35),
      ))
    }

@delegate:ResourceContentHash(-1_546_201_349)
internal val Res.string.timecard_weekday_thursday: StringResource by lazy {
      StringResource("string:timecard_weekday_thursday", "timecard_weekday_thursday", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23292, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26343, 37),
      ))
    }

@delegate:ResourceContentHash(-1_546_622_456)
internal val Res.string.timecard_weekday_tuesday: StringResource by lazy {
      StringResource("string:timecard_weekday_tuesday", "timecard_weekday_tuesday", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23334, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26381, 36),
      ))
    }

@delegate:ResourceContentHash(-1_546_651_380)
internal val Res.string.timecard_weekday_wednesday: StringResource by lazy {
      StringResource("string:timecard_weekday_wednesday", "timecard_weekday_wednesday", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23375, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26418, 38),
      ))
    }

@delegate:ResourceContentHash(-157_658_811)
internal val Res.string.tips_music_play_list_need_to_pubic: StringResource by lazy {
      StringResource("string:tips_music_play_list_need_to_pubic", "tips_music_play_list_need_to_pubic", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23418, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26457, 154),
      ))
    }

@delegate:ResourceContentHash(-1_414_835_872)
internal val Res.string.tmdb_api_read_access_token: StringResource by lazy {
      StringResource("string:tmdb_api_read_access_token", "tmdb_api_read_access_token", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23561, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26612, 70),
      ))
    }

@delegate:ResourceContentHash(905_266_818)
internal val Res.string.tmdb_api_token_help: StringResource by lazy {
      StringResource("string:tmdb_api_token_help", "tmdb_api_token_help", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23632, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26683, 95),
      ))
    }

@delegate:ResourceContentHash(1_351_951_936)
internal val Res.string.tmdb_attribution_notice: StringResource by lazy {
      StringResource("string:tmdb_attribution_notice", "tmdb_attribution_notice", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23724, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26779, 127),
      ))
    }

@delegate:ResourceContentHash(2_558_432)
internal val Res.string.tmdb_attribution_title: StringResource by lazy {
      StringResource("string:tmdb_attribution_title", "tmdb_attribution_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23852, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26907, 82),
      ))
    }

@delegate:ResourceContentHash(-615_627_052)
internal val Res.string.tmdb_au: StringResource by lazy {
      StringResource("string:tmdb_au", "tmdb_au", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23931, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26990, 27),
      ))
    }

@delegate:ResourceContentHash(-17_216_913)
internal val Res.string.tmdb_ca: StringResource by lazy {
      StringResource("string:tmdb_ca", "tmdb_ca", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23963, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27018, 23),
      ))
    }

@delegate:ResourceContentHash(-276_724_543)
internal val Res.string.tmdb_cn: StringResource by lazy {
      StringResource("string:tmdb_cn", "tmdb_cn", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 23991, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27042, 23),
      ))
    }

@delegate:ResourceContentHash(-433_710_528)
internal val Res.string.tmdb_de: StringResource by lazy {
      StringResource("string:tmdb_de", "tmdb_de", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24015, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27066, 27),
      ))
    }

@delegate:ResourceContentHash(-107_598_238)
internal val Res.string.tmdb_es: StringResource by lazy {
      StringResource("string:tmdb_es", "tmdb_es", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24039, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27094, 23),
      ))
    }

@delegate:ResourceContentHash(1_653_586_262)
internal val Res.string.tmdb_fr: StringResource by lazy {
      StringResource("string:tmdb_fr", "tmdb_fr", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24067, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27118, 23),
      ))
    }

@delegate:ResourceContentHash(-1_372_936_811)
internal val Res.string.tmdb_image_type_backdrop: StringResource by lazy {
      StringResource("string:tmdb_image_type_backdrop", "tmdb_image_type_backdrop", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24091, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27142, 44),
      ))
    }

@delegate:ResourceContentHash(-78_202_058)
internal val Res.string.tmdb_in: StringResource by lazy {
      StringResource("string:tmdb_in", "tmdb_in", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24136, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27187, 23),
      ))
    }

@delegate:ResourceContentHash(-1_222_177_398)
internal val Res.string.tmdb_it: StringResource by lazy {
      StringResource("string:tmdb_it", "tmdb_it", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24160, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27211, 23),
      ))
    }

@delegate:ResourceContentHash(1_898_032_507)
internal val Res.string.tmdb_jp: StringResource by lazy {
      StringResource("string:tmdb_jp", "tmdb_jp", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24188, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27235, 23),
      ))
    }

@delegate:ResourceContentHash(-611_705_278)
internal val Res.string.tmdb_kr: StringResource by lazy {
      StringResource("string:tmdb_kr", "tmdb_kr", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24212, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27259, 23),
      ))
    }

@delegate:ResourceContentHash(767_638_495)
internal val Res.string.tmdb_lang_de_de: StringResource by lazy {
      StringResource("string:tmdb_lang_de_de", "tmdb_lang_de_de", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24236, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27283, 31),
      ))
    }

@delegate:ResourceContentHash(1_798_876_669)
internal val Res.string.tmdb_lang_en_us: StringResource by lazy {
      StringResource("string:tmdb_lang_en_us", "tmdb_lang_en_us", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24268, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27315, 35),
      ))
    }

@delegate:ResourceContentHash(638_729_854)
internal val Res.string.tmdb_lang_es_es: StringResource by lazy {
      StringResource("string:tmdb_lang_es_es", "tmdb_lang_es_es", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24300, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27351, 35),
      ))
    }

@delegate:ResourceContentHash(1_657_687_720)
internal val Res.string.tmdb_lang_fr_fr: StringResource by lazy {
      StringResource("string:tmdb_lang_fr_fr", "tmdb_lang_fr_fr", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24340, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27387, 31),
      ))
    }

@delegate:ResourceContentHash(1_558_682_554)
internal val Res.string.tmdb_lang_it_it: StringResource by lazy {
      StringResource("string:tmdb_lang_it_it", "tmdb_lang_it_it", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24372, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27419, 35),
      ))
    }

@delegate:ResourceContentHash(-757_094_953)
internal val Res.string.tmdb_lang_ja_jp: StringResource by lazy {
      StringResource("string:tmdb_lang_ja_jp", "tmdb_lang_ja_jp", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24412, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27455, 35),
      ))
    }

@delegate:ResourceContentHash(-611_297_820)
internal val Res.string.tmdb_lang_ko_kr: StringResource by lazy {
      StringResource("string:tmdb_lang_ko_kr", "tmdb_lang_ko_kr", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24444, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27491, 31),
      ))
    }

@delegate:ResourceContentHash(1_699_934_750)
internal val Res.string.tmdb_lang_ru_ru: StringResource by lazy {
      StringResource("string:tmdb_lang_ru_ru", "tmdb_lang_ru_ru", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24476, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27523, 35),
      ))
    }

@delegate:ResourceContentHash(-627_206_165)
internal val Res.string.tmdb_lang_type_poster: StringResource by lazy {
      StringResource("string:tmdb_lang_type_poster", "tmdb_lang_type_poster", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24508, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27559, 37),
      ))
    }

@delegate:ResourceContentHash(1_982_905_537)
internal val Res.string.tmdb_lang_zh_cn: StringResource by lazy {
      StringResource("string:tmdb_lang_zh_cn", "tmdb_lang_zh_cn", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24546, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27597, 47),
      ))
    }

@delegate:ResourceContentHash(-703_567_044)
internal val Res.string.tmdb_lang_zh_tw: StringResource by lazy {
      StringResource("string:tmdb_lang_zh_tw", "tmdb_lang_zh_tw", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24586, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27645, 51),
      ))
    }

@delegate:ResourceContentHash(352_630_760)
internal val Res.string.tmdb_now_playing: StringResource by lazy {
      StringResource("string:tmdb_now_playing", "tmdb_now_playing", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24626, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27697, 40),
      ))
    }

@delegate:ResourceContentHash(212_636_733)
internal val Res.string.tmdb_popular: StringResource by lazy {
      StringResource("string:tmdb_popular", "tmdb_popular", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24667, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27738, 32),
      ))
    }

@delegate:ResourceContentHash(1_211_563_423)
internal val Res.string.tmdb_ru: StringResource by lazy {
      StringResource("string:tmdb_ru", "tmdb_ru", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24704, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27771, 23),
      ))
    }

@delegate:ResourceContentHash(1_433_508_319)
internal val Res.string.tmdb_top_rated: StringResource by lazy {
      StringResource("string:tmdb_top_rated", "tmdb_top_rated", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24732, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27795, 34),
      ))
    }

@delegate:ResourceContentHash(202_534_364)
internal val Res.string.tmdb_uk: StringResource by lazy {
      StringResource("string:tmdb_uk", "tmdb_uk", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24771, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27830, 35),
      ))
    }

@delegate:ResourceContentHash(-1_341_718_705)
internal val Res.string.tmdb_upcoming: StringResource by lazy {
      StringResource("string:tmdb_upcoming", "tmdb_upcoming", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24795, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27866, 33),
      ))
    }

@delegate:ResourceContentHash(63_348_156)
internal val Res.string.tmdb_us: StringResource by lazy {
      StringResource("string:tmdb_us", "tmdb_us", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24833, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27900, 35),
      ))
    }

@delegate:ResourceContentHash(286_045_839)
internal val Res.string.topic_id_or_slug: StringResource by lazy {
      StringResource("string:topic_id_or_slug", "topic_id_or_slug", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27936, 36),
      ))
    }

@delegate:ResourceContentHash(67_780_524)
internal val Res.string.under_construction: StringResource by lazy {
      StringResource("string:under_construction", "under_construction", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24857, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27973, 50),
      ))
    }

@delegate:ResourceContentHash(1_625_780_404)
internal val Res.string.unknown: StringResource by lazy {
      StringResource("string:unknown", "unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24896, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28024, 27),
      ))
    }

@delegate:ResourceContentHash(-1_709_819_232)
internal val Res.string.unsplash_api_key: StringResource by lazy {
      StringResource("string:unsplash_api_key", "unsplash_api_key", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25006, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28142, 52),
      ))
    }

@delegate:ResourceContentHash(-39_943_964)
internal val Res.string.unsplash_api_key_help: StringResource by lazy {
      StringResource("string:unsplash_api_key_help", "unsplash_api_key_help", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 24920, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28052, 89),
      ))
    }

@delegate:ResourceContentHash(1_818_067_249)
internal val Res.string.unsplash_collections_photos: StringResource by lazy {
      StringResource("string:unsplash_collections_photos", "unsplash_collections_photos", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28195, 63),
      ))
    }

@delegate:ResourceContentHash(1_402_535)
internal val Res.string.unsplash_feed_photos: StringResource by lazy {
      StringResource("string:unsplash_feed_photos", "unsplash_feed_photos", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28259, 44),
      ))
    }

@delegate:ResourceContentHash(-1_167_863_841)
internal val Res.string.unsplash_orientation: StringResource by lazy {
      StringResource("string:unsplash_orientation", "unsplash_orientation", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 25247, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28508, 52),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString5Resources(map: MutableMap<String, StringResource>) {
  map.put("showcase_style", Res.string.showcase_style)
  map.put("slide_effect", Res.string.slide_effect)
  map.put("slow", Res.string.slow)
  map.put("small", Res.string.small)
  map.put("sort_rule", Res.string.sort_rule)
  map.put("sort_rule_date_asc", Res.string.sort_rule_date_asc)
  map.put("sort_rule_date_desc", Res.string.sort_rule_date_desc)
  map.put("sort_rule_default", Res.string.sort_rule_default)
  map.put("sort_rule_name_asc", Res.string.sort_rule_name_asc)
  map.put("sort_rule_name_desc", Res.string.sort_rule_name_desc)
  map.put("sort_rule_random", Res.string.sort_rule_random)
  map.put("source", Res.string.source)
  map.put("source_name", Res.string.source_name)
  map.put("source_name_already_exists", Res.string.source_name_already_exists)
  map.put("source_preference", Res.string.source_preference)
  map.put("source_type_category_album_services", Res.string.source_type_category_album_services)
  map.put("source_type_category_local", Res.string.source_type_category_local)
  map.put("source_type_category_network_storage", Res.string.source_type_category_network_storage)
  map.put("source_type_category_other_online_content", Res.string.source_type_category_other_online_content)
  map.put("source_type_category_third_party", Res.string.source_type_category_third_party)
  map.put("source_type_gallery", Res.string.source_type_gallery)
  map.put("source_type_local", Res.string.source_type_local)
  map.put("sources", Res.string.sources)
  map.put("sub_folder_hint", Res.string.sub_folder_hint)
  map.put("subtle", Res.string.subtle)
  map.put("system", Res.string.system)
  map.put("system_default", Res.string.system_default)
  map.put("system_screensaver", Res.string.system_screensaver)
  map.put("telegram_channel", Res.string.telegram_channel)
  map.put("terms_of_use", Res.string.terms_of_use)
  map.put("test_connection", Res.string.test_connection)
  map.put("thanks", Res.string.thanks)
  map.put("thanks_for_your_feed_back", Res.string.thanks_for_your_feed_back)
  map.put("the_number_of_files_may_be_too_large_please_wait", Res.string.the_number_of_files_may_be_too_large_please_wait)
  map.put("theme_style", Res.string.theme_style)
  map.put("theme_style_atlas", Res.string.theme_style_atlas)
  map.put("theme_style_aurora", Res.string.theme_style_aurora)
  map.put("theme_style_coast", Res.string.theme_style_coast)
  map.put("theme_style_forest", Res.string.theme_style_forest)
  map.put("theme_style_herbarium", Res.string.theme_style_herbarium)
  map.put("theme_style_journal", Res.string.theme_style_journal)
  map.put("theme_style_noir", Res.string.theme_style_noir)
  map.put("theme_style_oled", Res.string.theme_style_oled)
  map.put("theme_style_orchid", Res.string.theme_style_orchid)
  map.put("theme_style_signal", Res.string.theme_style_signal)
  map.put("theme_style_sunset", Res.string.theme_style_sunset)
  map.put("time_unit_minute", Res.string.time_unit_minute)
  map.put("time_unit_second", Res.string.time_unit_second)
  map.put("timecard_date_pattern", Res.string.timecard_date_pattern)
  map.put("timecard_weather_loading", Res.string.timecard_weather_loading)
  map.put("timecard_weather_unavailable", Res.string.timecard_weather_unavailable)
  map.put("timecard_weekday_friday", Res.string.timecard_weekday_friday)
  map.put("timecard_weekday_monday", Res.string.timecard_weekday_monday)
  map.put("timecard_weekday_saturday", Res.string.timecard_weekday_saturday)
  map.put("timecard_weekday_sunday", Res.string.timecard_weekday_sunday)
  map.put("timecard_weekday_thursday", Res.string.timecard_weekday_thursday)
  map.put("timecard_weekday_tuesday", Res.string.timecard_weekday_tuesday)
  map.put("timecard_weekday_wednesday", Res.string.timecard_weekday_wednesday)
  map.put("tips_music_play_list_need_to_pubic", Res.string.tips_music_play_list_need_to_pubic)
  map.put("tmdb_api_read_access_token", Res.string.tmdb_api_read_access_token)
  map.put("tmdb_api_token_help", Res.string.tmdb_api_token_help)
  map.put("tmdb_attribution_notice", Res.string.tmdb_attribution_notice)
  map.put("tmdb_attribution_title", Res.string.tmdb_attribution_title)
  map.put("tmdb_au", Res.string.tmdb_au)
  map.put("tmdb_ca", Res.string.tmdb_ca)
  map.put("tmdb_cn", Res.string.tmdb_cn)
  map.put("tmdb_de", Res.string.tmdb_de)
  map.put("tmdb_es", Res.string.tmdb_es)
  map.put("tmdb_fr", Res.string.tmdb_fr)
  map.put("tmdb_image_type_backdrop", Res.string.tmdb_image_type_backdrop)
  map.put("tmdb_in", Res.string.tmdb_in)
  map.put("tmdb_it", Res.string.tmdb_it)
  map.put("tmdb_jp", Res.string.tmdb_jp)
  map.put("tmdb_kr", Res.string.tmdb_kr)
  map.put("tmdb_lang_de_de", Res.string.tmdb_lang_de_de)
  map.put("tmdb_lang_en_us", Res.string.tmdb_lang_en_us)
  map.put("tmdb_lang_es_es", Res.string.tmdb_lang_es_es)
  map.put("tmdb_lang_fr_fr", Res.string.tmdb_lang_fr_fr)
  map.put("tmdb_lang_it_it", Res.string.tmdb_lang_it_it)
  map.put("tmdb_lang_ja_jp", Res.string.tmdb_lang_ja_jp)
  map.put("tmdb_lang_ko_kr", Res.string.tmdb_lang_ko_kr)
  map.put("tmdb_lang_ru_ru", Res.string.tmdb_lang_ru_ru)
  map.put("tmdb_lang_type_poster", Res.string.tmdb_lang_type_poster)
  map.put("tmdb_lang_zh_cn", Res.string.tmdb_lang_zh_cn)
  map.put("tmdb_lang_zh_tw", Res.string.tmdb_lang_zh_tw)
  map.put("tmdb_now_playing", Res.string.tmdb_now_playing)
  map.put("tmdb_popular", Res.string.tmdb_popular)
  map.put("tmdb_ru", Res.string.tmdb_ru)
  map.put("tmdb_top_rated", Res.string.tmdb_top_rated)
  map.put("tmdb_uk", Res.string.tmdb_uk)
  map.put("tmdb_upcoming", Res.string.tmdb_upcoming)
  map.put("tmdb_us", Res.string.tmdb_us)
  map.put("topic_id_or_slug", Res.string.topic_id_or_slug)
  map.put("under_construction", Res.string.under_construction)
  map.put("unknown", Res.string.unknown)
  map.put("unsplash_api_key", Res.string.unsplash_api_key)
  map.put("unsplash_api_key_help", Res.string.unsplash_api_key_help)
  map.put("unsplash_collections_photos", Res.string.unsplash_collections_photos)
  map.put("unsplash_feed_photos", Res.string.unsplash_feed_photos)
  map.put("unsplash_orientation", Res.string.unsplash_orientation)
}
